<template>
  <v-dialog v-model="show" max-width="600">
    <template v-slot:activator="{on}">
      <slot name="activator" :on="on">
        <v-btn v-if="!editing" v-on="on" color="white" class="success mr-2" icon small><v-icon>mdi-plus</v-icon></v-btn>
        <v-btn v-else v-on="on" color="orange" icon small><v-icon>edit</v-icon></v-btn>
      </slot>
    </template>
    <v-card :loading="loading" :disabled="loading">
      <CardTitle :title="(editing ? 'Edit' : 'Create') + ' License'">
        <template v-if="editing" v-slot:actions>
          <Confirm @confirmed="destroy" message="You will not be able to undo this.">
            <template v-slot:activator="{on}">
              <v-btn color="error" v-on="on" small tile outlined>Deactivate</v-btn>
            </template>
          </Confirm>
        </template>
      </CardTitle>
      <v-card-text>
        <v-alert type="error"  v-if="checkLicenseResults.length > 0">
          <v-row no-gutters>
            <v-col cols="12" v-for="(license, index) in checkLicenseResults" :key="index">
              <strong>{{ license.license }}</strong> already exists for <a :href="`/directory_V2/${license.customer_id}`" class="white--text" target="_blank"><strong>{{ license.customer.primary_name.name }}</strong></a>.
            </v-col>
          </v-row>
        </v-alert>
        <v-form ref="form" @submit.prevent="submit">
          <v-autocomplete
              label="Type"
              v-model="form.license_type_id"
              :items="licenseTypes"
              item-text="desc"
              item-value="id"
              :rules="rules"
          >
          </v-autocomplete>
          <v-text-field
              label="License"
              v-model="form.license"
              :rules="rules"
              @keyup="debounceLicensesCheck"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
      <CardActions @close="close" @submit="submit"></CardActions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "License",
  props:{
    editing:{
      type: Boolean,
      default: false
    },
    data: {
      default: false,
    },
    customer_id: null,
  },
  computed:{
    licenseTypes(){
      return this.$store.$db().model('licenseTypes').all();
    }
  },
  watch:{
    show(v){
      if(v && this.editing){
        this.form = {...this.data};
      }
    }
  },
  mounted(){
    if(this.editing){
      this.form = {...this.data};
    }
  },
  data:() => ({
    show: false,
    loading: false,
    checkLicenseResults: [],
    debouncer: null,
    form: {
      customer_id: null,
      license: null,
      license_type_id: null,
      user_id: 1
    },
    rules: [
      v => !!v || "This field is required"
    ]
  }),
  methods:{
    debounceLicensesCheck(){
      if(this.debouncer){
        clearTimeout(this.debouncer);
      }
      this.debouncer = setTimeout(() => {
        this.checkLicense();
      }, 500);
    },
    async checkLicense(){
      this.licensesCheckResults = [];
      if(!this.form.license){
        return;
      }
      const query = await this.$store.$db().model('licenses').api().fetch({
        with: 'customer.primaryName',
        where: {
          key: 'license',
          value: this.form.license
        }
      }, "",null,false,false);
      this.$set(this, 'checkLicenseResults', query.response.data)
      // this.licensesCheckResults = query.response.data;
    },
    close(){
      if(!this.editing){
        this.$refs.form.reset();
      }else{
        this.form = {...this.data};
      }
      this.show = false;
    },
    async submit(){
      this.loading = true;
      if(!this.$refs.form.validate()) return;
      try{
        if(!this.editing) this.form.customer_id = this.customer_id;
        await this.$store.$db().model('licenses').api().save(this.form)
        this.$store.dispatch("showSuccess", "Saved!")
        this.close();
      }catch(err){
        console.log(err)
        this.$store.dispatch("showError", "An error occurred while saving.")
      }finally {
        this.loading = false;
      }
    },
    async destroy(){
      if(!this.editing) return;
      this.loading =true;
      try{
        await this.$store.$db().model('licenses').api().destroy(this.form.id, `{customer-${this.customer_id}} | ${this.form.license_type_id}`)
      }catch(e){
        this.$store.dispatch("showError", "Failed to deactivate.")
      }finally {
        this.loading = false;
      }
    }
  },
}
</script>

<style scoped>

</style>
